/**
 * Base class for connection routers.
 */
export class ConnectionRouterBase {
    constructor() { }
}
